import  { useEffect, useState } from 'react';
import translate from '../../services/Translation/lang';

export default function RetailTotalBetsBadge() {
  const [totalBets, setTotalBets] = useState(0);
  const [, setLangTick] = useState(0);

  useEffect(() => {
    // expose setter za broj tiketa
    window.setRetailTicketsLenght = setTotalBets;

    // rerenderuj kada se promeni jezik
    const onLangChange = () => setLangTick((x) => x + 1);
    window.addEventListener('lang:changed', onLangChange);

    return () => {
      delete window.setRetailTicketsLenght;
      window.removeEventListener('lang:changed', onLangChange);
    };
  }, []);

  return (
    <>
      {translate('active_bets')}
      <div className="pod-tabs-nav-badge">
        {totalBets}
      </div>
    </>
  );
}
